import {NotifyPropertyChanged} from '../utils/NotifyPropertyChanged.js';
import {NotificationParams} from './NotificationParams.js';

export class NotificationPopupModel extends NotifyPropertyChanged {
    isVisible: boolean = false;
    params: NotificationParams;

    get canShow(): boolean {
        return !this.isVisible;
    }

    private static _instance: NotificationPopupModel;

    static get instance(): NotificationPopupModel {
        if (!NotificationPopupModel._instance) {
            NotificationPopupModel._instance = new NotificationPopupModel();
        }
        return NotificationPopupModel._instance;
    }

    private constructor() {
        super();
    }

    show(params: NotificationParams) {
        this.params = params;
        this.isVisible = true;
        this.notifyPropertyChanged('isVisible');
        setTimeout(() => {
            this.hide();
        }, 5500);
    }

    hide() {
        this.isVisible = false;
        this.notifyPropertyChanged('isVisible');
    }
}
